import Row from "components/grid/row";
import TextInput from "./inputs/text";
import TextareaInput from "./inputs/textarea";
import { Fragment, FunctionComponent, useEffect, useState } from "react";
import Col from "components/grid/col";
import Button from "components/button";
import ImportEmailTemplateModal from "components/import-email-template-modal";
import { Locale, LocaleString } from "models/locale";
import { useLocale, useLocales } from "stores/hooks/locale";
import { repair } from "lib/locale";
import { useFormContext } from "react-hook-form";
import {
  EmailTemplateType,
  ListEmailTemplate,
} from "models/list-email-template";
import { adminDoGetListEmailTemplates } from "services/admin/list-email-template";
import { useList } from "stores/hooks/list";
import { faBolt } from "components/icon-library";

interface FormEmailRowsProps {
  allowImport?: boolean;

  // if set, show only in a certain locale
  locale?: Locale;

  // if true, the fields are disabled
  disabled?: boolean;

  // if chosen, try to prefill the form using that template
  prefill?: EmailTemplateType;
}

const FormEmailRows: FunctionComponent<FormEmailRowsProps> = ({
  allowImport = false,
  locale,
  disabled = false,
  prefill,
}) => {
  const list = useList();
  const { setValue, trigger } = useFormContext();
  const uiLocale = useLocale();
  const locales = useLocales();
  const [importti, toggleImport] = useState(false);
  const [emailTemplates, toggleEmailTemplates] = useState<ListEmailTemplate[]>(
    [],
  );

  useEffect(() => {
    const fetch = async () => {
      if (list) {
        // fetch email templates
        const ets = await adminDoGetListEmailTemplates(list);
        toggleEmailTemplates(ets);

        // if prefill enabled
        if (prefill) {
          const template = ets.find((et) => et.type === prefill);
          if (template) {
            setValue(
              "subject",
              locale ? template.subject[locale] : template.subject,
            );
            setValue(
              "message",
              locale ? template.message[locale] : template.message,
            );
          }
        }
      }
    };
    fetch();
  }, [list?.uuid]);

  const handleImport = async (subject: LocaleString, message: LocaleString) => {
    // repair
    repair(subject, locale || uiLocale, locales);
    repair(message, locale || uiLocale, locales);

    // overwrite values
    setValue("subject", locale ? subject[locale] : subject);
    setValue("message", locale ? message[locale] : message);

    // force validation
    trigger();
  };

  return (
    <Fragment>
      <Row>
        <Col>
          <TextInput
            label="Sähköpostin otsikko"
            name="subject"
            required
            translations={locale === undefined}
            disabled={disabled}
          />
        </Col>
      </Row>
      {
        <Row>
          <Col>
            <TextareaInput
              label="Sähköpostin sisältö"
              name="message"
              required
              translations={locale === undefined}
              disabled={disabled}
            />
          </Col>
        </Row>
      }
      {allowImport && (
        <Row>
          <Col>
            <Button
              type="tertiary"
              preIcon={faBolt}
              onClick={() => toggleImport(true)}
              disabled={disabled}
            >
              Käytä sähköpostimallia
            </Button>
          </Col>
        </Row>
      )}
      {importti && (
        <ImportEmailTemplateModal
          emailTemplates={emailTemplates}
          onImport={handleImport}
          onClose={async () => toggleImport(false)}
        />
      )}
    </Fragment>
  );
};

export default FormEmailRows;
